<div class="flex flex-col w-full p-4 border rounded-md border-grey-300">

    <div class="flex flex-row items-center justify-between">
        <h5>Certificate of Appreciation</h5>
        <div class="flex">
            <form [formGroup]="formGroup" class="flex flex-col w-full">
                <div class="flex flex-row items-center gap-2">
                    <label class="body-default-regular" for="certificateOfAppreciationYes">
                        <input
                        type="radio"
                        id="certificateOfAppreciationYes"
                        name="yesNoCtrl"
                        [value]="true"
                        formControlName="yesNoCtrl"
                        class="mr-1"
                        />
                        Yes
                    </label>
                    <label class="body-default-regular" for="certificateOfAppreciationNo">
                        <input
                        type="radio"
                        id="certificateOfAppreciationNo"
                        name="yesNoCtrl"
                        [value]="false"
                        formControlName="yesNoCtrl"
                        class="mr-1"
                        />
                        No
                    </label>
                </div>
            </form>
        </div>
    </div>

</div>

